import React, { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import MonthFilterSelect from "../../../../Component/DigitalMarketing/MonthFilter";
import { useGetAppointmentsQuery } from "../../../../Service/dashboard";

const Appointments = () => {
  const [selectedMonth, setSelectedMonth] = useState("this Month");

  const monthOptions = [
    { value: "this Month", label: "This Month" },
    { value: "previous Month", label: "Previous Month" },
  ];

  const { data, refetch, isLoading } = useGetAppointmentsQuery(selectedMonth, {
    refetchOnMountOrArgChange: true,
  });

  const chartData: any = data?.data
    ? [...data.data].sort(
        (a: any, b: any) =>
          new Date(a.appointmentDate).getTime() - new Date(b.appointmentDate).getTime()
      )
    : [];

  return (
    <>
      <div className="d-flex justify-content-between">
        <div>
          <span className="dashboard-heading mb-4">Appointments</span>
        </div>
        <div>
          <MonthFilterSelect
            value={selectedMonth}
            onChange={setSelectedMonth}
            options={monthOptions}
          />
        </div>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="appointmentDate"
            type="category"
            tickFormatter={(tick) =>
              new Date(tick).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
              })
            }
          />
          <YAxis
            dataKey="appointment"
            type="number"
            label={{
              value: "Appointments",
              angle: -90,
              position: "insideLeft",
            }}
          />
          <Tooltip
            labelFormatter={(label) =>
              `Date: ${new Date(label).toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
              })}`
            }
          />
          <Legend />
          <Line
            dataKey="appointment"
            stroke="#8884d8"
            name="Appointments"
            isAnimationActive={!isLoading}
          />
        </LineChart>
      </ResponsiveContainer>
    </>
  );
};

export default Appointments;
